import { AddNew16 } from 'ui/icons/aurora/16px';
import { PrimaryButton } from 'ui/button';
import { BottomTooltip } from 'ui/tooltip';
import noop from 'utils/noop';
import { maxWidgets as maxNumberOfWidgets } from '../utils/dashboardUtils';

type AddWidgetButtonProps = {
  /** The max number of widgets allowed. */
  maxWidgets: number;
  /** Current number of widgets. */
  numberOfWidgets: number;
  onClick: () => void;
};

/**
 * AddWidgetButton
 * Button for adding widgets. Shows a popup message when maximum number of widgets is reached.
 * */
export const AddWidgetButton = ({
  maxWidgets = maxNumberOfWidgets,
  onClick = noop,
  numberOfWidgets,
}: AddWidgetButtonProps) => {
  const warning = numberOfWidgets >= maxWidgets - 5;
  const disabled = numberOfWidgets >= maxWidgets;

  const warningMessage = `You have ${numberOfWidgets} widgets. The maximum is ${maxWidgets} widgets.`;
  const maxWidgetsMessage = `You have reached the maximum of ${maxWidgets} widgets.`;

  return (
    <BottomTooltip
      isEnabled={warning}
      tooltipContent={disabled ? maxWidgetsMessage : warningMessage}
    >
      <PrimaryButton
        data-test="dashboard-add-widget-button"
        onClick={onClick}
        data-role="add-button"
        isDisabled={disabled}
      >
        <AddNew16 />
        <span>New widget</span>
      </PrimaryButton>
    </BottomTooltip>
  );
};
